module.exports = __webpack_public_path__ + "img/Skirt-Front-B1-Db-Ga-Hb-Ia.d75227fa.png";